import { makeStyles } from '@mui/styles'
import { styled, Theme } from '@mui/material/styles'
import { Typography, Divider, IconButton } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import Drawer from '../../control/Drawer'
import Scrollbar from '../../control/Scrollbar'

type MapStationDetailMuxProps = {
    onClose: () => void
    data: MUXType | null
    title: string
    isOpen: boolean
}
const MapStationDetailMux = (props: MapStationDetailMuxProps) => {
    const { onClose, data, title, isOpen } = props
    const classes = useStyles()

    const getItemChannel = (tvChannels?: TVType[]) => {
        return (
            <StyledContainerList>
                {tvChannels?.map((item: TVType) => (
                    <StyledContainerListItem>
                        <StyledDivChannelLogo>
                            <StyledImg src={item.urlLogo} />
                        </StyledDivChannelLogo>
                        <StyledDivChannelNo>{`ช่อง ${item.no}`}</StyledDivChannelNo>
                        <StyledDivChannelName>{item.name}</StyledDivChannelName>
                    </StyledContainerListItem>
                ))}
            </StyledContainerList>
        )
    }

    return (
        <Drawer
            hideBackdrop
            isOpen={isOpen}
            inlineStyle={{ position: 'unset' }}
            overrideClass={{ paper: classes.drawerPaper }}
        >
            <StyledContainer>
                <StyledTitle>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            left: 10,
                            top: 15,
                        }}
                        className={classes.backIcon}
                    >
                        <ArrowBackIcon />
                    </IconButton>
                    <StyledTypography variant="body2">{title}</StyledTypography>
                </StyledTitle>
                <StyledContent>
                    <div style={{ width: '100%', height: '100%' }}>
                        <Scrollbar scrollbarTrackBorderRadius={10} scrollbarThumbBorderRadius={10}>
                            <StyledContentGroup>
                                {/* ผู้ให้บริการโครงข่ายฯ */}
                                {data?.provider && (
                                    <StyledDivRow>
                                        <StyledDivColumnLeft>
                                            <Typography>ผู้ให้บริการโครงข่ายฯ :</Typography>
                                        </StyledDivColumnLeft>
                                        <StyledDivColumnRight>
                                            <Typography>{data?.provider}</Typography>
                                        </StyledDivColumnRight>
                                    </StyledDivRow>
                                )}
                                {/* SFN */}
                                {data?.sfn && (
                                    <StyledDivRow>
                                        <StyledDivColumnLeft>
                                            <Typography>SFN/MFN ID :</Typography>
                                        </StyledDivColumnLeft>
                                        <StyledDivColumnRight>
                                            <Typography>{data?.sfn}</Typography>
                                        </StyledDivColumnRight>
                                    </StyledDivRow>
                                )}

                                <Divider className={classes.divider} />

                                <StyledTypoSectionTitle>ข้อมูลช่องรายการ</StyledTypoSectionTitle>
                                <StyledContainerMUX>{getItemChannel(data?.tvChannels)}</StyledContainerMUX>
                            </StyledContentGroup>
                        </Scrollbar>
                    </div>
                </StyledContent>
            </StyledContainer>
        </Drawer>
    )
}

export default MapStationDetailMux

const useStyles = makeStyles((theme: Theme) => ({
    drawerPaper: {
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    container: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    backIcon: {
        color: `${theme.palette.text.secondary} !important`,
    },
    divButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginLeft: theme.spacing(1),
    },
    icon: {
        color: `${theme.palette.primary.dark} !important`,
        marginRight: theme.spacing(1),
    },
    divider: {
        margin: '10px 0px !important',
    },
    dividerMUX: {
        margin: '5px 0px !important',
    },
    tooltip: {
        margin: '0px !important',
    },
    button: {
        width: '150px',
        minHeight: '37px',
    },
}))

const StyledContainer = styled('div')(({ theme }) => ({
    width: '350px',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
        width: '100%',
    },
}))

const StyledTitle = styled('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px 0px',
    backgroundColor: theme.palette.secondary.main,
    boxShadow: theme.palette.getContrastText('shadow-bottom'),
}))

const StyledTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    textAlign: 'center',
}))

const StyledContent = styled('div')(({ theme }) => ({
    display: 'flex',
    height: `calc(100% - 63px)`,
}))

const StyledContentGroup = styled('div')(({ theme }) => ({
    margin: '20px',
}))

const StyledDivRow = styled('div')(({ theme }) => ({
    display: 'flex',
    width: '100%',
    margin: '5px 0px',
}))

const StyledDivColumnLeft = styled('div')(({ theme }) => ({
    whiteSpace: 'nowrap',
}))

const StyledDivColumnRight = styled('div')(({ theme }) => ({
    marginLeft: '15px',
}))

const StyledTypoSectionTitle = styled(Typography)(({ theme }) => ({
    color: `${theme.palette.secondary.dark} !important`,
    fontWeight: 'bold',
}))

const StyledContainerMUX = styled('div')(({ theme }) => ({
    padding: '5px 0px',
}))

const StyledContainerList = styled('div')(({ theme }) => ({
    alignItems: 'center',
    width: '100%',
    margin: '5px 0px',
}))

const StyledContainerListItem = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    marginBottom: '10px',
    borderRadius: '3px',
    backgroundColor: '#f0f7ff',
    border: `1px solid ${theme.palette.text.disabled}`,
}))

const StyledDivChannelLogo = styled('div')(({ theme }) => ({
    minWidth: '100px',
    maxHeight: '50px',
    display: 'flex',
    alignItems: 'center',
}))

const StyledDivChannelNo = styled('div')(({ theme }) => ({
    minWidth: '70px',
    display: 'flex',
    alignItems: 'left',
}))

const StyledDivChannelName = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'left',
}))

const StyledImg = styled('img')(({ theme }) => ({
    width: '85px',
}))
